<script setup lang="ts">
/// <reference types="vue/macros-global" />
withDefaults(
  defineProps<{
    errorMessages?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
  }>(),
  {
    errorMessages: () => [],
    readonly: false,
    disabled: false,
    label: '',
    placeholder: '',
  }
);

const select = defineModel<string | number | object>();
</script>
<template>
  <v-autocomplete
    v-model="select"
    flat
    clearable
    variant="solo-filled"
    hide-details="auto"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    v-bind="$attrs"
  ></v-autocomplete>
</template>

<style></style>
